import { IComponentOptions } from "angular";
import { ContractInstanceComponentController } from "./controller";

export const vsComponentName = "contractInstanceComponent";

export const contractInstanceComponentOptions: IComponentOptions = {
  controller: ContractInstanceComponentController,
  controllerAs: "stateController",
  template: require("!html-loader!./index.html").default,
};
